<div *ngIf="!hasLogin" class="cer-padding-wide flex-column cer-flex-100">
  <p>Du er ikke logget ind</p>
  <p>
    <button [routerLink]="['/authentication/login']">
      <mat-icon>login</mat-icon><span>Log ind</span>
    </button>
  </p>
</div>
<div *ngIf="hasLogin" class="cer-padding-wide flex-column cer-flex-100">
  <div class="flex-column flex-100" *ngIf="!(userId)">
    <h3>Ingen adgang</h3>
    <div>Afvent eller kontakt venligst administrator for status.</div>
  </div>
  <div *ngIf="userId" class="flex-column cer-flex-100">
    <div *ngIf="!hasNotifications" class="flex-column">
      <h3><mat-icon>notifications</mat-icon>Notifikationer for:</h3>
      <p>Du har ingen notifikationer.</p>
    </div>
    <div *ngIf="hasNotifications" class="flex-column cer-flex-100">
      <div div class="flex-fixed">
        <h3>
          <mat-icon color="accent" [matBadgeHidden]="unreadCount == 0" [matBadge]="unreadCount"
            matBadgeColor="primary">notifications</mat-icon>Notifikationer:
        </h3>
      </div>
      <div class="flex-column flex-grow cer-flex-100-h cer-flex-limit-height">
        <ul class="chat-list">
          <ng-container *ngFor="let data of userNotifications; let i = index">
            <li class="chat-list-name" *ngIf="true">
              <div>
                <mat-icon color="info" class="icon-small" *ngIf="data.isNotified">done</mat-icon>{{
                formatDateRelative(data.created) }} {{ data.fromShortName }}
              </div>
            </li>
            <li class="chat-list-item cer-float-left cer-subdued">
              <a [routerLink]="data.url" [queryParams]="data.queryParams"
              >
                <div>{{ data.txt }}</div>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div>
